<template>
  <div class="sub-title">
    {{ title }}
  </div>
</template>

<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "subTitle",
  components: {},
  props: {
    /** 标题 */
    title: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({});
    onMounted(() => {});

    return {
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.sub-title {
}
</style>
